export const redirectFromOldUrl = ({ isTemplate, id }: { isTemplate: boolean; id: number }) => {
  const scheme = window.location.protocol
  const newHost = window.location.host.replace('email-editor.', '')
  const newPath = `/dashboard/${isTemplate ? 'email-template' : 'mailing'}/${id}/edit`
  window.location.href = `${scheme}//${newHost}${newPath}`
}
